
import { Opcao } from '@/dominio/formulario/questoes/opcoes/Opcao';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'OpcaoComponent',
    props: {
        opcao: {
            type: Opcao,
            required: true,
        },
        questaoId: {
            type: String,
            required: true,
        },
        modelValue: {
            type: Opcao,
            required: false,
        },
    },
    computed: {
        idRadio() {
            return this.questaoId + '-' + this.opcao.getId();
        },
        isChecked() {
            return this.modelValue?.getId() === this.opcao.getId();
        },
    },
    methods: {
        emitirOpcaoSelecionada() {
            this.$emit('opcaoSelecionada', this.opcao);
        },
    },
    emits: ['opcaoSelecionada'],
});
